import { httpRequest } from "@services/http";
import { Credit } from "@models/credit.model";
import { CreditSerializer } from "@models/serializers/creditSerializer";

export class CommandListCredits {
  async run(contractId: number, params?: { budget_id?: number }): Promise<Credit[]> {
    const query = new URLSearchParams();
    if (params?.budget_id != null) query.set("budget_id", String(params.budget_id));
    const qs = query.toString();
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/credits/${qs ? `?${qs}` : ""}`;
    const response = await httpRequest<any[]>(url, { method: "GET" });
    return CreditSerializer.fromJsonList(response);
  }
}
